module.exports = __webpack_public_path__ + "img/icon-alert.ca7d1f9d.svg";